import uniqBy from 'lodash/uniqBy';
import type { IPrimaryIssuer } from '@/creditflowresearch/domain/vo/IDeal';

interface IDealWithIssuers {
  primaryIssuer: IPrimaryIssuer,
  issuers?: IPrimaryIssuer[],
  additionalIssuers?: IPrimaryIssuer[],
}

export const collectIssuers = (deal: IDealWithIssuers): IPrimaryIssuer[] => {
  if (!deal?.primaryIssuer) {
    return [];
  }

  const issuers = deal.issuers || [];
  const additionalIssuers = deal.additionalIssuers || [];

  const allIssuers = [deal.primaryIssuer, ...issuers, ...additionalIssuers];

  return uniqBy(allIssuers, 'viewId');
};

export const collectValidIssuers = (deal: IDealWithIssuers): IPrimaryIssuer[] => {
  const allIssuers = collectIssuers(deal);

  return allIssuers.filter((issuer) => issuer?.viewId || issuer?.id);
};
